<template>
  <b-modal id="checkStageModal" title="Просмотр этапа" ref="checkStageModal"
           header-bg-variant="primary" header-text-variant="light"
           ok-title="Перейти" cancel-title="Отмена" ok-variant="primary"
           cancel-variant="outline-primary" @ok="onCheck" :ok-disabled="!(selectedRole)"
  >
    <div>Выберите роль</div>
    <b-form-select
      v-model="selectedRole"
      :options="rolesOptions"
    ></b-form-select>
  </b-modal>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'CheckStageModal',
  data() {
    return {
      selectedRole: null,
      rolesOptions: []
    }
  },
  watch: {
    stageIndex() {
      if (this.stageIndex || this.stageIndex === 0) {
        this.rolesOptions = []
        const roles = this.getStageRoles(
          this.course.stages[this.stageIndex],
        )
        roles.forEach((r) => {
          this.rolesOptions.push({
            value: r,
            text: r
          })
        })
      }
    }
  },
  computed: {
    ...mapGetters({
      course: 'training/getTrainingCourse'
    })
  },
  props: {
    stageIndex: {
      type: Number,
      default() {
        return null
      }
    }
  },
  methods: {
    ...mapMutations({
      setTrainingRole: 'training/setTrainingRole',
      setTrainingStep: 'training/setTrainingStep'
    }),
    onCheck() {
      this.setTrainingRole(this.selectedRole)
      this.setTrainingStep(this.course.stages[this.stageIndex])
      this.$router.push(`${this.$route.path}/stages/${this.stageIndex}`)
    },
    getStageRoles(stage) {
      return Array.from(
        new Set(stage.rolesOnPanel.map((roleOnPanel) => roleOnPanel.role)),
      )
    }
  }
}
</script>

<style scoped>

</style>
